import React from "react";
import { Fragment } from "react";
import Configuration from "../admin/AccordionComponents/Configuration";
import UserAndEmail from "../admin/AccordionComponents/UserAndEmail";
import ManualRate from "../admin/AccordionComponents/ManualRate";
import ViewBroadcast from "../admin/AccordionComponents/ViewBroadcast";
import ViewConfiguration from "../admin/AccordionComponents/ViewConfiguration";

const Main = ({ screen }) => {
  const screenNames = {
    "Configuration": <Configuration />,
    "User And Email Broadcast Management": <UserAndEmail />,
    "Manual Rate Broadcast": <ManualRate />,
    "View Broadcast": <ViewBroadcast />,
    "View Configuration" : <ViewConfiguration />
  };

  return <Fragment>{screenNames[screen]}</Fragment>;
};

export default Main;
